import React from 'react';
import { cn } from '@/utils/cn';

export function ProjectProgressMilestones({ milestones }: { milestones: any[] }) {
  return (
    <div className="bg-white rounded-md border border-slate-100 p-4  space-y-4">
      <div className="flex items-center justify-between border-b border-slate-50 pb-2">
        <h3 className="text-sm font-normal text-slate-900">Các mốc quan trọng</h3>
        <button className="text-xs font-normal text-emerald-600 hover:underline">Tất cả</button>
      </div>

      <div className="space-y-4 relative">
        {/* Line kết nối */}
        <div className="absolute left-[5px] top-2 bottom-2 w-0.5 bg-slate-50" />
        
        {milestones.map((m, idx) => (
          <div key={idx} className="flex gap-3 relative z-10">
            <div className={cn(
              "w-2.5 h-2.5 rounded-full mt-1 border-2 border-white  shrink-0",
              m.status === 'Hoàn thành' ? 'bg-emerald-500' : m.status === 'Đang thực hiện' ? 'bg-blue-500' : 'bg-slate-200'
            )} />
            <div className="flex-1 flex justify-between items-start min-w-0">
               <div className="space-y-0.5">
                  <h4 className="text-xs font-normal text-slate-700 truncate group-hover:text-emerald-600 transition-colors">{m.name}</h4>
                  <p className="text-xs font-normal text-slate-400">{m.date}</p>
               </div>
               <span className={cn("text-xs font-normal px-1.5 py-0.5 rounded", m.status === 'Đúng hạn' ? 'bg-emerald-50 text-emerald-600' : 'bg-rose-50 text-rose-600')}>{m.status}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
